import React, { useState } from 'react';
import { BoxWrapper, Prompt, Button } from 'components/Base';
import Icons from 'components/Icons';
import { handleFileChange, updateFirmConfig, handleFileDelete } from './utils';

interface FileUploadComponentProps {
  title: string;
  subTitle?: string;
  fieldName: string;
  buttonLabel: string;
  initialFile: any;
  setFirmConfig: (config: any) => void;
  note?: string;
  isFirmAdmin: boolean;
  tooltip?: string;
}

const FileUploadComponent = ({
  title,
  subTitle,
  fieldName,
  buttonLabel,
  initialFile,
  setFirmConfig,
  note,
  isFirmAdmin,
  tooltip
}: FileUploadComponentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(initialFile) as any;
  const [preview, setPreview] = useState(initialFile) as any;

  const updateConfig = (formData: any, file: any = null) =>
    updateFirmConfig(
      setFile,
      setPreview,
      setIsModalOpen,
      setFirmConfig,
      fieldName,
      formData,
      file
    );

  const onFileChange = (event: any) =>
    handleFileChange(event, updateConfig, fieldName);

  const onFileDelete = () => handleFileDelete(updateConfig, fieldName);

  return (
    <>
      <div>
        <BoxWrapper title={title} tooltip={tooltip} subTitle={subTitle}>
          <div style={{ margin: '8px', padding: '8px' }}>
            {file ? (
              <div>
                {preview && (
                  <img
                    src={preview}
                    alt="Preview"
                    style={{ maxWidth: '300px' }}
                  />
                )}
              </div>
            ) : (
              <>No {title} has been uploaded</>
            )}
            {isFirmAdmin && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  marginTop: '1rem'
                }}
              >
                <Button component="label">
                  {buttonLabel}
                  <input
                    type="file"
                    accept="image/*"
                    style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                    onChange={onFileChange}
                  />
                </Button>
                {file && (
                  <div
                    onClick={() => setIsModalOpen(true)}
                    style={{ display: 'flex', cursor: 'pointer' }}
                  >
                    <Icons.DeleteIcon />
                  </div>
                )}
              </div>
            )}
            {note && (
              <div style={{ marginTop: '1rem', fontStyle: 'italic' }}>
                {note}
              </div>
            )}
          </div>
        </BoxWrapper>
      </div>
      <Prompt
        isOpen={isModalOpen}
        title={`Are you sure you want to delete the ${title}?`}
        confirmAction={onFileDelete}
        isProcessing={false}
        cancelAction={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FileUploadComponent;
